import React from "react";
import InputDate from "components/atoms/InputDate";
import InputRadio from "components/atoms/InputRadio";
import InputSelect from "components/atoms/InputSelect";
import { MonthOptions } from "utils/constant";
import moment from "moment";

const PeriodeFilter = ({
  periodeLaporan,
  setPeriodeLaporan,
  periodeLaporanValue,
  setPeriodeLaporanValue,
}) => {
  const renderInput = () => {
    if (periodeLaporan === "yearly") {
      return (
        <InputDate
          value={periodeLaporanValue}
          onChange={(e) => {
            const selectedYear = moment(e).format("YYYY");
            setPeriodeLaporanValue({ year: selectedYear });
          }}
          placeholder={"Pilih tahun"}
          dateFormat={"YYYY"}
        />
      );
    }
    return null;
  };

  return (
    <>
      <InputRadio
        name={`level_${periodeLaporan}`}
        isRequired
        options={[
          { label: "Tahunan", value: "yearly" },
        ]}
        onChange={(e) => {
          setPeriodeLaporan(e.target.value);
          setPeriodeLaporanValue("");
        }}
        selectedOption={periodeLaporan}
      />
      <div className="advanced-filter">{renderInput()}</div>
    </>
  );
};

export default PeriodeFilter;
